import { render, staticRenderFns } from "./MdPatientInsurances.vue?vue&type=template&id=77696ecc&"
import script from "./MdPatientInsurances.vue?vue&type=script&lang=js&"
export * from "./MdPatientInsurances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports